import { render } from "./ShipToFields.vue?vue&type=template&id=168128a4&scoped=true"
import script from "./ShipToFields.vue?vue&type=script&lang=js"
export * from "./ShipToFields.vue?vue&type=script&lang=js"

import "./ShipToFields.vue?vue&type=style&index=0&id=168128a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168128a4"]])

export default __exports__